import React, { memo } from 'react';
import { ReportType, ClientCustomCalendarModel } from '../../../models';
import ReportSettingDeleteBalance from './DeleteBalance';
import ReportSettingRollforward from './Rollforward';
import ReportSettingMaturity from './Maturity';
import { ReportTypeSetting } from '../../../models/reportTypeSetting';
import { ReportSettingState } from './index';
import ReportSettingCommitment from './Commitment';
import ReportSettingPercentageRent from './PercentageRent';
import ReportSettingFiscalRollforward from './FiscalRollforward';
import ReportSettingStartEnd from './StartEnd';
import ReportSettingSublease from './Sublease';
import ReportSettingWeightedAverage from './WeightedAverage';
import ReportSettingDisclosure from './Disclosure';
import ReportSettingFromTo from './FromTo';
import ReportSettingLeaseCommitment from './LeaseCommitment';
import ReportSettingAssetAmort from './AssetAmort';
import ReportSettingPAndL from './PAndL';
import ReportSettingAP from './AP';
import ReportSettingInforAP from './InforAP';
import ReportSettingCustom from './Custom';
import ReportSettingROUAssets from './ROUAssets';

interface ReportSettingProps {
  reportType?: ReportType;
  isInforReport?: boolean;
  onChange?: (reportSetting: ReportSettingState) => void;
  reportSettingState: ReportSettingState;
  reportTypeSetting: ReportTypeSetting;
  isAllowPIT: boolean;
  customCalendarSettings?: ClientCustomCalendarModel;
}

const ReportSettingComponents = {
  [ReportType.custom]: ReportSettingCustom,
  [ReportType.rollforward]: ReportSettingRollforward,
  [ReportType.maturity]: ReportSettingMaturity,
  [ReportType.deleteBalance]: ReportSettingDeleteBalance,
  [ReportType.committment]: ReportSettingCommitment,
  [ReportType.fiscalRollforward]: ReportSettingFiscalRollforward,
  [ReportType.percentageRent]: ReportSettingPercentageRent,
  [ReportType.startEnd]: ReportSettingStartEnd,
  [ReportType.sublease]: ReportSettingSublease,
  [ReportType.weightedAverage]: ReportSettingWeightedAverage,
  [ReportType.disclosure]: ReportSettingDisclosure,
  [ReportType.fromTo]: ReportSettingFromTo,
  [ReportType.leaseCommittment]: ReportSettingLeaseCommitment,
  [ReportType.assetAmort]: ReportSettingAssetAmort,
  [ReportType.effectOfStandardAdoptionPAndL]: ReportSettingPAndL,
  [ReportType.ap]: ReportSettingAP,
  [ReportType.rouAssets]: ReportSettingROUAssets,
  [ReportType.infor]: ReportSettingInforAP,
};

type Props = {
  onChange: (updatedValue: ReportSettingState) => void;
  reportSettingState: ReportSettingState;
  reportTypeSetting: ReportTypeSetting;
  customCalendarSettings: ClientCustomCalendarModel;
};

const renderReportSettingByType = (
  reportType: ReportType,
  isInforReport: boolean,
  reportSettingState: ReportSettingState,
  reportTypeSetting: ReportTypeSetting,
  isAllowPIT: boolean,
  onChange?: (reportSetting: ReportSettingState) => void,
  customCalendarSettings?: ClientCustomCalendarModel,
): JSX.Element => {
  const component = isInforReport
    ? ReportSettingComponents[ReportType.infor]
    : ReportSettingComponents[reportType];
  const ReportSettingComponent = component as React.ComponentType<Props>;
  const props = {
    reportSettingState,
    reportTypeSetting,
    isAllowPIT,
    onChange,
    customCalendarSettings,
  };
  return <ReportSettingComponent {...props} />;
};

function ReportSetting({
  reportType,
  isInforReport,
  onChange,
  reportSettingState,
  reportTypeSetting,
  isAllowPIT,
  customCalendarSettings,
}: ReportSettingProps): JSX.Element {
  return renderReportSettingByType(
    reportType,
    isInforReport,
    reportSettingState,
    reportTypeSetting,
    isAllowPIT,
    onChange,
    customCalendarSettings,
  );
}

export default memo(ReportSetting);
